
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/credits-billing",
      function () {
        return require("private-next-pages/docs/credits-billing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/credits-billing"])
      });
    }
  